export class AddBuildingRangeToBuildingGroupDto {
  buildingIds: string[];
  buildingGroupId: string;
  surveyId: string;

  constructor(data: {
    buildingIds: string[];
    buildingGroupId: string;
    surveyId: string;
  }) {
    this.buildingIds = data.buildingIds;
    this.buildingGroupId = data.buildingGroupId;
    this.surveyId = data.surveyId;
  }
}
